
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { PortfolioFormValues } from '@/hooks/useAddPortfolioForm';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface PortfolioFormProps {
  form: UseFormReturn<PortfolioFormValues>;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting?: boolean;
}

const PortfolioForm: React.FC<PortfolioFormProps> = ({ form, onSubmit, isSubmitting = false }) => {
  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="space-y-4">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Portfolio Name*</FormLabel>
              <FormControl>
                <Input 
                  placeholder="Enter portfolio name" 
                  {...field} 
                  disabled={isSubmitting}
                  required
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <Button 
          type="submit" 
          className="w-full mt-4"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" /> 
              Creating...
            </>
          ) : "Create Portfolio"}
        </Button>
      </form>
    </Form>
  );
};

export default PortfolioForm;
